// @flow
import React, { Fragment } from 'react';
import { withRouter, Route, Switch } from 'react-router';
import {
  MdDirectionsRun,
  MdSettings,
} from 'react-icons/lib/md';
import i18n from 'i18n-js';

import OpenButton from '../../OpenButton';
import CardHeader from '../../CardHeader';
import CardHeaderTitleContainer from '../../CardHeaderTitleContainer';
import CardHeaderTitle from '../../CardHeaderTitle';
import CardHeaderIcon from '../../CardHeaderIcon';
import CardHeaderLeftGroup from '../../CardHeaderLeftGroup';
import CardContent from '../../CardContent';
import BackendExitMethodsList from './BackendExitMethodsList';
import BackendExitMethodsNavigation from './BackendExitMethodsNavigation';
import BackendExitMethodsDoorsList from './BackendExitMethodsDoorsList';
import CreateExitMethodPopup from '../../CreateExitMethodPopupContent';
import CreateGatePopup from '../../CreateGatePopupContent';
import Popup from '../../Popup';
import AddGatewayUsersPopup from '../../AddGatewayUserPopup';
import CardHeaderRightGroup from '../../CardHeaderRightGroup';

const RoutesView = () => (
  <Fragment>
    <CardHeader size="big">
      <CardHeaderLeftGroup>
        <CardHeaderIcon Icon={MdDirectionsRun} />
        <CardHeaderTitleContainer>
          <CardHeaderTitle title={i18n.t('common.gateway', { count: 2 })} />
        </CardHeaderTitleContainer>
        <AddGatewayUsersPopup />
        <CardHeaderRightGroup>
          {/* <OpenButton
            title={i18n.t('common.settings')}
            Icon={MdSettings}
            clearMargins
            disabled
            id="gatewayUsersPopup"
          /> */}
        </CardHeaderRightGroup>
      </CardHeaderLeftGroup>
    </CardHeader>
    <CardContent>
      <BackendExitMethodsNavigation />
      <Switch>
        <Route
          path="/admin/backend/exit-methods"
          component={BackendExitMethodsList}
          exact
        />
        <Route
          path="/admin/backend/exit-methods/list"
          component={BackendExitMethodsList}
        />
        <Route
          path="/admin/backend/exit-methods/doors"
          component={BackendExitMethodsDoorsList}
        />
      </Switch>
    </CardContent>
    <Popup
      id="createexitmethod"
      theme="main"
      transitionMs={600}
    >
      <CreateExitMethodPopup />
    </Popup>
    <Popup
      id="creategate"
      theme="main"
      transitionMs={600}
    >
      <CreateGatePopup />
    </Popup>
  </Fragment>
);

export default withRouter(RoutesView);



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendExitMethodsView/index.jsx